import CryptoJS from "crypto-js";

const KEY = "180719";
const IV = "191807";

export const loadFromSessionStorage = () => {
  try {
    const serializedState = sessionStorage.getItem("state");
    if (serializedState === null) {
      return undefined;
    }
    const decrypted = CryptoJS.AES.decrypt(serializedState, KEY, {
      iv: IV as any,
    }).toString(CryptoJS.enc.Utf8);
    return JSON.parse(decrypted);
  } catch {
    return undefined;
  }
};

export const saveToSessionStorage = (state: any) => {
  try {
    const serializedState = JSON.stringify(state);
    const encrypted = CryptoJS.AES.encrypt(serializedState, KEY, {
      iv: IV as any,
    }).toString();
    sessionStorage.setItem("state", encrypted);
  } catch (e) {
    console.log(e);
  }
};
